import { TagField } from "@hireroo/app-store/widget/e/TagField";
import { useTranslation } from "@hireroo/i18n";
import type { Widget } from "@hireroo/presentation";

import { type GenerateSuggestionsPropsArgs, useGenerateSuggestionsProps } from "./useGenerateSuggestionsProps";

export type GenerateSpotTagFieldPropsArgs = {
  name: string;
  variant: Widget.TagFieldProps["variant"];
  loading: boolean;
} & GenerateSuggestionsPropsArgs;

export const useGenerateProps = (args: GenerateSpotTagFieldPropsArgs): Widget.TagFieldProps => {
  const { t } = useTranslation();
  const { suggestions } = useGenerateSuggestionsProps(args);

  const openTagField = TagField.useOpenTagField();
  const deleteDialogTargetTagName = TagField.useDeleteDialogTargetTagName();

  return {
    name: args.name,
    variant: args.variant,
    placeholder: t("タグを選択"),
    suggestions: suggestions,
    loading: args.loading,
    open: openTagField,
    onFocus: () => {
      args.refresh();
    },
    onOpen: () => {
      TagField.openTagField();
    },
    onClose: () => {
      if (deleteDialogTargetTagName) {
        return;
      }
      TagField.closeTagField();
    },
  };
};
